import { Injectable } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs'
import { MessagehandlerService } from './messagehandler.service'

@Injectable({
   providedIn: 'root'
})
export class NavigationService {

   private urlHistory: string[] = []

   get previousUrl(): string {
      return this.urlHistory[this.urlHistory.length - 2]
   }

   get currentUrl(): string {
      return this.urlHistory[this.urlHistory.length - 1]
   }

   constructor(private router: Router, private message: MessagehandlerService) { }

   initialize() {
      this.router.events
         .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
         .subscribe((event: NavigationEnd) => {
            this.urlHistory.push(event.url)
            if (event.url !== '/' && event.url.indexOf('/research') === -1) {
               this.message.emitAppEvent({ event: 'navigation', status: 'ready', value: event.url })
            }
            setTimeout(() => {
               this.focusOnFirstRelevantItem()
            })
         })
   }

   focusOnFirstRelevantItem() {
      // check if in web-component or page
      const webComponent = document.getElementsByTagName('cdi-research-assistant').item(0)
      const rootEl = webComponent && webComponent.shadowRoot ? webComponent.shadowRoot : document

      const focusableElement = rootEl.querySelectorAll('[data-focus-on-load]').item(0) as HTMLElement
      // TODO should we add a fallback to focus on the first element if no element is found?

      if (focusableElement)  {
         setTimeout(() => focusableElement.focus(), 0)
      }
   }

   goBack() {
      this.urlHistory.pop()
      const previousUrl = this.urlHistory.pop()
      if (previousUrl) {
         this.router.navigateByUrl(previousUrl)
      }
   }
}
